<div [formGroup]="form">
    <div class="row">
        <div *ngIf="form.value.identifier" class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input [class]="'form-control autogenerated'" [disabled]="true" formControlName="code" [type]="'text'">
                <label label>{{'administration.sectionsManagement.certification.code' | translate}}</label>
            </apc-form-input>
        </div>

        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input name="name" [class]="'form-control'" formControlName="name" [type]="'text'" [isRequired]="true">
                <label label>{{'administration.sectionsManagement.certification.name' | translate}}</label>
            </apc-form-input>
        </div>

    </div>
    <div class="row mt-3">
        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input [class]="'form-control'" formControlName="vendor" [type]="'text'" [isRequired]="true">
                <label label>{{'administration.sectionsManagement.certification.vendor' | translate}}</label>
            </apc-form-input>
        </div>

        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input [class]="'form-control'" formControlName="urlDescription" [type]="'text'">
                <label label>{{'administration.sectionsManagement.certification.urlDescription' | translate}}</label>
            </apc-form-input>
        </div>
    </div>

    <div class="row mt-3">
        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input [class]="'form-control'" formControlName="type" [type]="'text'">
                <label label>{{'administration.sectionsManagement.certification.type' | translate}}</label>
            </apc-form-input>
        </div>

        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input [class]="'form-control'" formControlName="subtype" [type]="'text'">
                <label label>{{'administration.sectionsManagement.certification.subtype' | translate}}</label>
            </apc-form-input>
        </div>
    </div>
    <div class="row mt-3">
        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input [class]="'form-control'" formControlName="defaultExpiration" [type]="'number'">
                <label label>{{'administration.sectionsManagement.certification.expiration' | translate}}</label>
            </apc-form-input>
        </div>
        <div [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">

        </div>
    </div>
    <div class="row mt-5">
        <div *ngIf="badgeImage" class="form-group" [ngClass]="getClassEditForm()">
            <img class="badge-url" [src]="badgeImage" alt="badge" loading="lazy" />
        </div>
        <div *ngIf="!badgeImage" class="form-group" [ngClass]="getClassEditForm()">
            <img class="badge-url" src="assets/img/badge.png" alt="badge" loading="lazy" />
        </div>

        <div *ngIf="getEditForm()" class="form-group col-lg-6">
            <label class="file-upload-not" [ngClass]="fileRequired ? 'file-required' : ''">
                <input type="file" (change)="handleFileInput($event.target['files'])" />
            </label>
            <span style="font-size: 13px">{{'buttons.help.imageFormat' | translate}}</span>
        </div>
    </div>
</div>